var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBellMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.5527344,31.8691406l-3.2363281-6.4707031C38.109375,24.9833984,38,24.5185547,38,24.0556641V16 c0-7.7197266-6.2802734-14-14-14S10,8.2802734,10,16v8.0556641c0,0.4628906-0.109375,0.9277344-0.3164062,1.3417969 l-3.2363281,6.4716797C6.1542969,32.4541016,6,33.109375,6,33.7636719C6,36.0996094,7.9003906,38,10.2363281,38h27.5273438 C40.0996094,38,42,36.0996094,42,33.7636719C42,33.109375,41.8457031,32.4541016,41.5527344,31.8691406z M37.7636719,36H10.2363281 C9.0029297,36,8,34.9970703,8,33.7636719c0-0.3447266,0.0820312-0.6914062,0.2363281-1l3.2363281-6.4726562 C11.8173828,25.6005859,12,24.8271484,12,24.0556641V16c0-6.6171875,5.3828125-12,12-12s12,5.3828125,12,12v8.0556641 c0,0.7714844,0.1826172,1.5449219,0.5273438,2.2363281l3.2363281,6.4716797C39.9179688,33.0722656,40,33.4189453,40,33.7636719 C40,34.9970703,38.9970703,36,37.7636719,36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,44c-2.2060547,0-4-1.7939453-4-4h-2c0,3.3085938,2.6914062,6,6,6s6-2.6914062,6-6h-2 C28,42.2060547,26.2060547,44,24,44z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellMedium);
export default __webpack_public_path__ + "static/media/bell--medium.b85c20a0416bf51024a16bcc32edc867.svg";
export { ForwardRef as ReactComponent };